import { AbstractControl, ValidatorFn } from '@angular/forms'

/**
 * Validates US and Canada phone numbers (NANP format).
 * Expects 10-digit input (area code + number), typically masked as (000) 000-0000.
 * Valid area codes and exchange codes must start with 2-9.
 */
export function PhoneNumberValidator(regionCode: string): ValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value || control.value === '') {
      return null
    }

    // Strip all non-digit characters (mask, spaces, dashes, parens)
    const digits = control.value.replace(/\D/g, '')

    // NANP: 10 digits, area code (NPA) and exchange (NXX) start with 2-9
    const isValid = /^[2-9]\d{2}[2-9]\d{6}$/.test(digits)

    return isValid ? null : { [`${regionCode}-phone`]: true }
  }
}
